import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./FirebaseAuth"; // Assuming this is your custom auth hook
import { getDocDataById, getDocDataByRef } from "../models/DataFunctions"; // Import your Firestore function
import { or } from "firebase/firestore";
import { use } from "echarts";

export async function checkPageAccessV2(
  userData = null,
  orgData = null,
  workspaceData = null,
  plan_needed = null,
  workspace_forbidden = true
) {
  // check if user is in the org
  // check if workspaceData is null
  // check if orgData.facturation?.plans.includes(plan_needed)
  if (!userData) {
    return false;
  }
  if (!orgData) {
    return false;
  }
  if (workspaceData && workspace_forbidden) {
    console.warn("Workspace data provided but workspace access is forbidden.");
    return false;
  }
  if (!workspaceData && !workspace_forbidden) {
    console.warn(
      "No workspace data provided but workspace access is required."
    );
    return false;
  }
  if (!(orgData.users_id || []).includes(userData.id)) {
    console.warn("User is not part of the organization.");
    return false;
  }
  let granted = true;

  if (plan_needed === "expert") {
    granted = orgData.facturation?.plan === "expert";
  } else if (plan_needed === "premium") {
    granted = ["premium", "expert"].includes(orgData.facturation?.plan);
  } else if (plan_needed === "basic") {
    granted = ["basic", "premium", "expert"].includes(
      orgData.facturation?.plan
    );
  } else if (plan_needed === "free") {
    granted = ["free", "basic", "premium", "expert"].includes(
      orgData.facturation?.plan
    );
  }
  if (!granted) {
    console.warn(
      `User's organization does not have the required plan: ${plan_needed}`
    );
    return false;
  }

  return true;
}
